import axios from "axios";
import Cookies from "js-cookie";
import moment from "moment";
import { ApiList, ApiObject } from "../utils/Api";
import { basename } from "../utils/Url";
import { axiosConfig } from "../utils/axios/config";
import { defaultApiBuilder, defaultApiWithCustomUrlBuilder } from "../utils/axios/apiBuilder";
import { parseJSON } from "../utils/date";
import { getOrderQueryDirection } from "../utils/ordering";

const apiCommonWithCustomUrl = defaultApiWithCustomUrlBuilder(parseJSON)
const apiCommon = defaultApiBuilder(parseJSON)
const apiCommonObject = defaultApiBuilder(ApiObject)
const apiCommonList = defaultApiBuilder(ApiList)

export const AxiosUserAPI = {
  getCurrent: async ({ signal }) => {
    const params = {
      expand: ['active_employee._extra', 'active_employee.name'].join(',')
    };
    const response = await apiCommonObject.get(`/users/current_user/`, { params, signal });
    return response.data;
  }
}

export const AxiosEmployeeAreaAPI = {
  getForArea: async (
    { area_id, active = true, ordering = null, page = 1 },
    { signal }
  ) => {
    const params = {
      expand: ['area', 'employee.name'].join(','),
      active,
      area: area_id,
      page
    };
    if (ordering) params.ordering = getOrderQueryDirection(ordering);

    const response = await apiCommon.get(`/employee_areas/`, { params, signal });
    return response.data;
  },
  getForEmployee: async (
    { employee_id, ordering = null, page = 1 },
    { signal }
  ) => {
    const params = {
      expand: ['area', 'employee.name'].join(','),
      employee: employee_id,
      page
    };
    if (ordering) params.ordering = getOrderQueryDirection(ordering);

    const response = await apiCommon.get(`/employee_areas/`, { params, signal });
    return response.data;
  },
  changeArea: async (
    [{ employee, new_area, change_date, review_access }],
    { signal }
  ) => {
    const response = await apiCommonWithCustomUrl.post(
      employee._actions.change_area,
      {
        area: new_area,
        start_date: moment(change_date).format("YYYY-MM-DD"),
        review_access: review_access,
      },
      { signal }
    );
    return response.data;
  }
}

export const AxiosEmployeePositionAPI = {
  getForPosition: async (
    { position_id, active = true, ordering = null, page = 1 },
    { signal }
  ) => {
    const params = {
      expand: ['position', 'employee.name'].join(','),
      active,
      position: position_id,
      page
    };
    if (ordering) params.ordering = getOrderQueryDirection(ordering);

    const response = await apiCommon.get(`/employee_positions/`, { params, signal });
    return response.data;
  },
  getForEmployee: async (
    { employee_id, ordering = null, page = 1 },
    { signal }
  ) => {
    const params = {
      expand: ['position', 'employee.name'].join(','),
      employee: employee_id,
      page
    };
    if (ordering) params.ordering = getOrderQueryDirection(ordering);
 
    const response = await apiCommon.get(`/employee_positions/`, { params, signal });
    return response.data;
  },
  changePosition: async (
    [{ employee, new_position, change_date, review_access }],
    { signal }
  ) => {
    const response = await apiCommonWithCustomUrl.post(
      employee._actions.change_position,
      {
        position: new_position,
        start_date: moment(change_date).format("YYYY-MM-DD"),
        review_access: review_access
      },
      { signal }
    );
    return response.data;
  },
}

export const AxiosSettingsAPI = {
  getAll: async ({ signal }) => {
    const response = await apiCommon.get(`settings/`, { signal });
    return response.data;
  }
}

export const AxiosGlobalSettingsApi = {
  getAll: async ({ signal }) => {
    const response = await apiCommon.get(`/global_settings/`, { signal });
    return response.data;
  }
};

export const MindsightAuthSystemApi = {
  getSystemName: async (authSystemUrl, systemOriginalName = "organograma") => {
    const api = axios.create({
      ...axiosConfig,
      baseURL: `${cleanUrlPath(authSystemUrl)}${basename}/api/v1/`
    });

    try {
      const params = {
        original_names: systemOriginalName
      };
      const { data } = await api.get(`mindsight_systems/`, { params });
      return data.length > 0 ? { name: data[0].name } : { name: "Organograma" };
    } catch (e) {
      return { name: "Organograma" };
    }
  },
  getAuthToggles: async authSystemUrl => {
    try {
      const api = axios.create({
        ...axiosConfig,
        baseURL: `${cleanUrlPath(authSystemUrl)}${basename}`
      });
      const response = await api.get(`/api/v1/auth_toggles/`);
      return response.data;
    } catch (e) {
      return {
        t001_use_new_home_design: false,
        t004_hide_logout_sankhyarh: false,
        enable_sankhya_menu: false
      };
    }
  }
};
const cleanUrlPath = url =>
  url.charAt(url.length - 1) === "/" ? url.slice(0, -1) : url;

export const AxiosCorporationsApi = {
  getAll: async ({ search = "", expand = [] }, { signal }) => {
    const params = {
      expand: expand.join(',')
    };
    if (search) params.search = search;

    const response = await apiCommonList.get(`/corporations/`, { params, signal });
    return response.data;
  }
};

export const AxiosBranchCorporationsApi = {
  getAll: async ({ signal }) => {
    const response = await apiCommonList.get(`/branch_corporations/`, { signal });
    return response.data;
  }
};
